import React from 'react';
import PropTypes from 'prop-types';
import { useId } from '@uifabric/react-hooks';
import { DirectionalHint, FontIcon, Text, TooltipDelay, TooltipHost } from 'office-ui-fabric-react';
import styles from './AdjustmentsList.style';
import PaymentStatusInfoItem from '../PaymentStatusInfoItem';
import { hasRole } from '../../utils/auth';
import getAdjustmentPaymentStatusInfo from '../../pages/AdjustmentDetails/AdjustmentPaymentStatusInfo';
import { formatDateString } from '../../utils';

const AdjustmentListPaymentStatus = ({ paymentStatus }) => {
  const tooltipId = useId('tooltip');
  if (paymentStatus) {
    const { primaryStatus, secondaryStatus, paymentDate, invoiceId, paymentReferenceNumber } =
      paymentStatus;

    if (primaryStatus && primaryStatus !== 'Not Available') {
      const isPaymentSent = primaryStatus && primaryStatus === 'PaymentSent';
      const paymentStatusInfoDetails = getAdjustmentPaymentStatusInfo(
        primaryStatus,
        secondaryStatus,
        paymentDate,
        invoiceId || null,
        paymentReferenceNumber || null,
        hasRole('partner'),
      );

      return (
        <div>
          <span
            className={
              isPaymentSent ? styles.paymentStatusSentIcon : styles.paymentStatusInProgressIcon
            }
          >
            <FontIcon
              iconName={isPaymentSent ? 'NavigateBackMirrored' : 'recent'}
              arianame={isPaymentSent ? 'NavigateBackMirrored' : 'recent'}
            />
          </span>

          {paymentStatusInfoDetails && (
            <TooltipHost
              id={tooltipId}
              content={PaymentStatusInfoItem({
                paymentStatusInfoDetails: paymentStatusInfoDetails.paymentStatusInfo,
                invoiceDetails: paymentStatusInfoDetails.invoice,
                paymentReferenceDetails: paymentStatusInfoDetails.paymentReference,
              })}
              delay={TooltipDelay.zero}
              directionalHint={DirectionalHint.topCenter}
              closeDelay={500}
              className={styles.toolTipHost}
              calloutProps={styles.callout}
              tooltipProps={styles.toolTip}
            >
              <Text
                variant="small"
                className={
                  isPaymentSent ? styles.paymentStatusDateUnderlined : styles.paymentStatusDate
                }
              >
                {isPaymentSent ? 'Sent' : 'Scheduled'}{' '}
                {isPaymentSent ? formatDateString(paymentDate, 'MMM d, yyyy') : ''}
              </Text>
            </TooltipHost>
          )}
        </div>
      );
    }

    return (
      <div>
        <span className={styles.paymentStatusInProgressIcon}>
          <FontIcon iconName="recent" arianame="recent" />
        </span>
        <Text variant="small" className={styles.paymentStatusDate}>
          In Process
        </Text>
      </div>
    );
  }

  return <span />;
};

AdjustmentListPaymentStatus.propTypes = {
  paymentStatus: PropTypes.bool,
};

AdjustmentListPaymentStatus.defaultProps = {
  paymentStatus: null,
};

export default AdjustmentListPaymentStatus;
